var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Fediverse extends Component {
    constructor() {
        super('Fediverse', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('home')) {
                this.restoreState();
                this.placeBoxes();
            }
            const btnToggleFediverseOriginalY = $('#btn-toggle-fediverse').position().y;
            const btnToggleFediverseMarginTop = $('#button-toggle-menu').viewportPosition().y + ($(window).width() < 992 ? $('#button-toggle-menu').height() + 10 : 0);
            $(window).on('scroll', () => {
                const btnToggleFediverseY = $('#btn-toggle-fediverse').position().y - window.scrollY;
                if (window.scrollY + btnToggleFediverseMarginTop > btnToggleFediverseOriginalY) {
                    $('#btn-toggle-fediverse').css({
                        position: 'fixed',
                        top: btnToggleFediverseMarginTop,
                        transform: 'none'
                    });
                }
                else {
                    $('#btn-toggle-fediverse').removeAttr('style');
                }
            });
            this.addEventListeners();
            this.success();
        });
    }
    /*
     * Add event listeners for fediverse interactions
     */
    addEventListeners() {
        // Toggle fediverse
        $('#btn-toggle-fediverse .fediverse-content').on('click', (event, button) => {
            button.parents('.fediverse').toggleClass('fediverse-disabled');
            const isEnabled = !button.hasClass('fediverse-disabled');
            sessionStorage.setItem('fediverse-enabled', isEnabled ? 'true' : 'false');
            if (isEnabled) {
                $('.fediverse:not(#btn-toggle-fediverse)').removeClass('d-none');
            }
            else {
                $('.fediverse:not(#btn-toggle-fediverse)').addClass('d-none');
            }
        });
        // Close fediverse box
        $('.btn-close-fediverse').on('click', (event, button) => {
            event.preventDefault();
            const box = button.parents('.fediverse');
            box.addClass('d-none');
            // Pause video if there is one
            this.pauseVideo(box);
        });
        // Expand fediverse box
        $('.fediverse-content').on('click', (event, content) => {
            const parent = content.parents('.fediverse');
            if (parent.hasClass('fediverse-static')) {
                this.playVideo(parent);
                return;
            }
            if (parent.hasClass('fediverse-sm'))
                return;
            if (parent.hasClass('is-expanded')) {
                /*parent.css('width', parent.css('--size'));
                content.css('height', content.css('--width-reduced'));
         
                this.pauseVideo(parent);
         
                parent.removeClass('is-expanded');*/
                location.href = $(content).data('href');
            }
            else {
                parent.addClass('is-expanded');
                setTimeout(() => {
                    const width = parseInt(content.find('div').css('width')) + parseInt(parent.css('--padding')) * 4 + 2;
                    const height = parseInt(content.find('div').css('height')) + parseInt(parent.css('--padding')) * 2 + 2;
                    parent.css('width', width);
                    content.css('height', height);
                    // If box get out of the viewport on x-axis after expansion, fix it to the right of the viewport
                    const boxRight = parent.position().x + width;
                    const viewportWidth = $(window).width();
                    if (boxRight > viewportWidth) {
                        console.log(`Box right edge (${boxRight}px) is outside the viewport (${viewportWidth}px). Adjusting position.`);
                        parent.css('left', viewportWidth - width - 20);
                    }
                    this.playVideo(parent);
                    this.placeNotice(parent, event);
                }, 40);
            }
        });
        // Notice follow mousemove
        $('.fediverse-content').on('mousemove', (event, content) => {
            if (content.parents('.fediverse').hasClass('is-expanded'))
                this.placeNotice(content.parents('.fediverse'), event);
        }).on('mouseleave', (event, content) => {
            content.parents('.fediverse').find('.fediverse-notice').addClass('d-none');
        });
        if ($('body').hasClass('home')) {
            $(window).on('scroll', () => {
                this.appearBoxes();
            });
            $(window).on('resize', () => {
                if ($(window).width() < 992)
                    return;
                this.placeBoxes();
            });
        }
        // Load more fediverse on click
        let offset = 0;
        $('.btn-load-more-fediverse').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            button.addClass('d-none');
            button.next().removeClass('d-none');
            const template = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'get_fediverses',
                    posts_per_page: 12,
                    offset: ++offset
                },
                dataType: 'html'
            });
            button.prev().append(template);
            button.next().addClass('d-none');
            button.removeClass('d-none');
            if (template.find('.fediverse').length < 12)
                button.remove();
        }));
    }
    /*
     * Restore the state of the fediverse boxes based on session storage
    */
    restoreState() {
        if (sessionStorage.getItem('fediverse-enabled') === 'false') {
            $('#btn-toggle-fediverse').addClass('fediverse-disabled');
            $('.fediverse:not(#btn-toggle-fediverse)').addClass('d-none');
        }
    }
    /*
     * Place the fediverse boxes on the page. Boxex are place randomly on the x-axis but never goes outside the viewport. On the y-axis, they are placed on box every half of the viewport height, starting after 1 viewport height from the top of the page, with a random offset of 0 to 20% of the viewport height.
     */
    placeBoxes() {
        const viewportHeight = $(window).height();
        $('.fediverse:not(.fediverse-sm)').each((box, index) => {
            const boxWidth = parseInt(box.css('width'));
            // Random x position, ensuring the box stays within the viewport
            //const x = Math.random() * (viewportWidth - boxWidth);
            const x = $('.container').position().x + Math.random() * ($('.container').width() - boxWidth);
            // Y position based on index, with a random offset
            //let y = viewportHeight + (index + 1) * (viewportHeight / 2) + Math.random() * (viewportHeight * 0.2);
            let y = $('.main-gallery').height() + (index * viewportHeight / 2) + Math.random() * (viewportHeight * 0.2);
            // Check if box overlaps with any .bloc-image .title, if it does, move it down until it doesn't
            let overlaps = false;
            do {
                overlaps = false;
                $('.bloc-image .title').each((title) => {
                    const titleTop = title.position().y;
                    const titleBottom = titleTop + title.height();
                    const boxTop = y;
                    const boxBottom = boxTop + parseInt(box.css('height'));
                    if (boxBottom > titleTop && boxTop < titleBottom) {
                        overlaps = true;
                        y += 25; // Move the box down by 20px and check again
                        return false; // Break the loop to check the new position
                    }
                });
            } while (overlaps);
            box.css({
                left: `${x}px`,
                top: `${y}px`
            });
        });
        // Remove boxes that are vertcialy after the footer
        const footerBottom = $('footer').position().y + $('footer').height();
        $('.fediverse:not(.fediverse-sm)').each((box) => {
            const boxBottom = box.position().y + box.height();
            if (boxBottom > footerBottom)
                box.remove();
        });
    }
    /*
     * Make fediverse boxes appear when they enter the 2/3 of the viewport
     */
    appearBoxes() {
        const viewportHeight = $(window).height();
        $('.fediverse:not(.fediverse-sm)').each((box) => {
            const boxTop = box.viewportPosition().y;
            if (boxTop < viewportHeight * 0.66) {
                box.removeClass('is-appearable');
            }
        });
    }
    playVideo(box) {
        const video = box.find('video').get(0);
        if (video) {
            if (!video.paused) {
                video.pause();
                box.find('.btn-play-video').removeClass('d-none');
            }
            else {
                video.currentTime = 0;
                video.play();
                box.find('.btn-play-video').addClass('d-none');
            }
        }
    }
    pauseVideo(box) {
        const video = box.find('video').get(0);
        if (video)
            video.pause();
        box.find('.btn-play-video').removeClass('d-none');
    }
    placeNotice(fediverse, event) {
        const notice = fediverse.find('.fediverse-notice');
        const parent = fediverse.find('.fediverse-content');
        notice.removeClass('d-none');
        notice.css({
            left: event.clientX - fediverse.viewportPosition().x,
            top: event.clientY - fediverse.viewportPosition().y
        });
    }
}
